import { Card, CardBody, Col } from 'reactstrap'
import { FlushList } from '../../../../Utils/Constants'
import { flushData, flushListData } from '../../../../Data/Ui-Kits/Lists/Lists'
import { LI, UL } from '../../../../AbstractElements'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const FlushLists = () => {
  return (
    <Col xl="4" md="12">
      <Card>
        <CardHeaderCommon title={FlushList} span={flushData} />
        <CardBody>
          <UL className="list-group-flush list-content">
            <LI>
              <i className="icofont icofont-arrow-right"></i>PRODUCT
            </LI>
            {flushListData.map((item, index) => (
              <LI key={index}>
                <i className="icofont icofont-arrow-right"></i>{item}
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  )
}

export default FlushLists